import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { PerformanceParameterService } from 'src/app/modules/services/performanceParameter/performance-parameter.service';
import { LoadingService } from '../../../loading/loading.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { catchError, debounceTime, distinctUntilChanged, of, switchMap } from 'rxjs';
import { AlertComponent } from '../../../alert/alert.component';

@Component({
  selector: 'app-modal-edit',
  templateUrl: './modal-edit.component.html',
  styleUrls: ['./modal-edit.component.scss']
})
export class ModalEditComponent implements OnInit {
  selectedOptionPatologia: any = null;
  filteredOptionsPatologia: any[] = [];
  searchControlPatologia = new FormControl(null, [Validators.required]); 
  selectedOptionTipoDeReparo: any;
  filteredOptionsTipoDeReparo: any[] = [];
  searchControlTipoDeReparo = new FormControl(null, [Validators.required]); // Adiciona validação de required
  prazoDeAtendimentoControl = new FormControl(null, [Validators.required]); // Validação: required e valor mínimo
  medidaPrazoDeAtendimentoControl = new FormControl('', [Validators.required]); // Adiciona validação de required para o select
  isEditMode: boolean = false;
  constructor(
    private performanceParameterService: PerformanceParameterService,
    private _snackBar: MatSnackBar,
    private loadingService: LoadingService,
    public _dialog: MatDialog,
    public _dialogRef: MatDialogRef<ModalEditComponent>,
    @Inject(MAT_DIALOG_DATA) public uploadData: any,
  ) { }
  ngOnInit(): void {
    this.getPatology();
    this.getTipoReparo();
    this.isEditMode = this.uploadData?.isEditMode
    this.searchControlPatologia.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((value: any) =>
        this.performanceParameterService.listPatology(0, 10, '', '', value).pipe(
          catchError(() => of([]))
        )
      )
    ).subscribe({
      next: (results: any) => {
        if (results?.content?.length) {
          this.filteredOptionsPatologia = results.content;
        } else {
          this.filteredOptionsPatologia = [];
        }
      },
      error: (err: any) => {
        this.filteredOptionsPatologia = [];
      }
    });
    this.searchControlTipoDeReparo.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap((value:any) =>
        this.performanceParameterService.listTypesofRepairs(0, 10,
          '',
          '',
          value
        )
          .pipe(
            catchError(() => of([]))
          ))
    ).subscribe({
      next: (results: any) => {
        if (results?.content?.length) {
          this.filteredOptionsTipoDeReparo = results.content;
        } else {
          this.filteredOptionsTipoDeReparo = [];
        }
      },
      error: (err: any) => {
        this.filteredOptionsTipoDeReparo = [];
      }
    })

    // this.prazoDeAtendimentoControl.valueChanges.subscribe(value => {
    //   this.atualizarMedida();
    // });

    this.medidaPrazoDeAtendimentoControl.valueChanges.subscribe((value) => {
      if (value === 'Imediato') {
        this.prazoDeAtendimentoControl.setValue(null);
        this.prazoDeAtendimentoControl.disable();
      } else {

        this.prazoDeAtendimentoControl.enable();
      }
    });

    if (this.isEditMode) {

      this.populatedFields();
    }
  }

  getPatology(){
  this.performanceParameterService.listPatology(0, 10, '', '', ).subscribe((resp:any)=>{
    this.filteredOptionsPatologia = resp.content;
  })
  }
  
  getTipoReparo(){
  this.performanceParameterService.listTypesofRepairs(0, 10, '', '', ).subscribe((resp:any)=>{
    this.filteredOptionsTipoDeReparo = resp.content;
  })
  }
  populatedFields() {

    const values = this.uploadData?.parameter

    this.selectedOptionPatologia = values?.pathology
    this.selectedOptionTipoDeReparo = values?.repairType
    this.searchControlPatologia.setValue(values?.pathology.name)
    this.searchControlTipoDeReparo.setValue(values?.repairType.name)
    const splitText = values?.serviceDeadline.split(' ')
    if(values?.serviceDeadline == "Imediato"){
      this.prazoDeAtendimentoControl.setValue(null);
      this.prazoDeAtendimentoControl.disable();
      this.medidaPrazoDeAtendimentoControl.setValue(values?.serviceDeadline)
    }else{
      this.prazoDeAtendimentoControl.setValue(splitText[0])
      this.medidaPrazoDeAtendimentoControl.setValue(splitText[1])
    }
    
  }

  onOptionSelectedTipoDeEfeito(event: any) {
    this.selectedOptionPatologia = event.option.value;
    this.searchControlPatologia.setValue(this.selectedOptionPatologia.name, { emitEvent: false });

    this.filteredOptionsPatologia = [];
  }
  onOptionSelectedTipoDeReparo(event: any) {
    this.selectedOptionTipoDeReparo = event.option.value;
    this.searchControlTipoDeReparo.setValue(this.selectedOptionTipoDeReparo.name, { emitEvent: false });
    this.filteredOptionsTipoDeReparo = [];
  }
  onSubmit() {
    let data
    if(this.medidaPrazoDeAtendimentoControl.value != 'Imediato'){
       data = {
        pathologyId: this.selectedOptionPatologia.id,
        repairTypeId: this.selectedOptionTipoDeReparo.id,
        serviceDeadline: `${this.prazoDeAtendimentoControl.value} ${this.medidaPrazoDeAtendimentoControl.value}`
      }
    }else{
      data = {
        pathologyId: this.selectedOptionPatologia.id,
        repairTypeId: this.selectedOptionTipoDeReparo.id,
        serviceDeadline: this.medidaPrazoDeAtendimentoControl.value
      }
    }

   
    if (

      !this.prazoDeAtendimentoControl.value &&
      this.medidaPrazoDeAtendimentoControl.value !== "Imediato"
    ) {
      this.openSnackBar("Todos os campos devem ser preenchidos.", 'error');

      return;
    }

    this._dialogRef.close(data)

  }

  back() {
    this._dialogRef.close()
  }

  atualizarMedida() {
 this.medidaPrazoDeAtendimentoControl.setValue('');

    
  }

  openSnackBar(description: string, type: string) {
    let classSnack = '';
    switch (type) {
      case 'sucess':
        classSnack = 'snacbar-sucess';
        break;
      case 'warning':
        classSnack = 'snacbar-warning';
        break;
      case 'error':
        classSnack = 'snacbar-error';
        break;
    }
    this._snackBar.openFromComponent(AlertComponent, {
      duration: 3000,
      panelClass: [classSnack, 'snackbar-custom'],
      data: { description: description, type: type },
      horizontalPosition: 'center',
      verticalPosition: 'top',
    });
  }
      preventNegativePaste(event: ClipboardEvent) {
    const pasted = event.clipboardData?.getData('text') ?? '';
    if (isNaN(Number(pasted)) || Number(pasted) < 0) {
      event.preventDefault();
    }
  }

  blockNegative(event: KeyboardEvent) {
    if (event.key === '-' || event.key === '—') {
      event.preventDefault();
    }
  }
}
